<template>
<div>


  <!-- SEARCH -->
  <!-- <section>
    <b-field position="is-centered">
        <b-input v-model="searchstring" placeholder="Search..." type="search" icon="magnify">
        </b-input>
        <b-button
              @click="filterLocally"
              icon-left="fas fa-search"
              type="is-primary">
            
          </b-button>

          <b-button
              @click="sortLocallyUp"
              icon-left="fas fa-sort-amount-up"
              type="is-primary">
            
          </b-button>
 
    </b-field>
  </section>
  <br> -->

  <!-- <b-notification :closable="false" v-if="!allContacts.length">
      Loading Contacts
      <b-loading :is-full-page="true" :active.sync="!allContacts.length" :can-cancel="true"></b-loading>
  </b-notification> -->


    <!-- :bordered="isBordered"
      :striped="isStriped"
      :narrowed="isNarrowed"
      :hoverable="isHoverable"
      :loading="isLoading"
      :focusable="isFocusable"
      :mobile-cards="hasMobileCards" -->

    <b-table
        :data="localSortedContacts"
        :mobile-cards=true
        :focusable=true
        :default-sort="[sortField, sortOrder]"
        detailed
        detail-key="id"
        :show-detail-icon="showDetailIcon"
        paginated
        per-page="10"
        >
        <template slot-scope="props">
            <!-- <b-table-column field="id" label="ID" width="40" numeric>
                {{ props.row.id }}
            </b-table-column> -->

            

            <b-table-column field="id" label="ID">
                <template v-if="showDetailIcon">
                    {{ props.row.id }}
                </template>
                <!-- <template v-else>
                    <a @click="toggle(props.row)">
                        {{ props.row.id }}
                    </a>
                </template> -->
            </b-table-column>

            <b-table-column field="class" label="Class"> 
              
              <ShowClassification :contact='props.row' style="margin-bottom: 1em;"/>

            </b-table-column>  

             <b-table-column field="displayname" label="Name" sortable>
                {{ props.row.displayName }}
            </b-table-column>

            <!-- <b-table-column field="firstname" label="Firstname" sortable>
                {{ props.row.firstname }}
            </b-table-column>

            <b-table-column field="name" label="Name" sortable>
                {{ props.row.name }}
            </b-table-column> -->

            <b-table-column field="total" label="Total" sortable>
                {{ props.row.status.custtotal }} €
            </b-table-column>
 
            <b-table-column field="lastcontact" label="LastContact [days ago]" centered>
                <span v-if="props.row.status.lastcontact.length > 0"> 
                  <!-- class="tag is-light" -->
                    {{ new Date(props.row.status.lastcontact).toLocaleDateString() }}
                </span>

                <span v-if="props.row.status.lastcontact.length > 0">
                  <span class="tag is-light">{{diffInDays(props.row.status.lastcontact)}} </span>
                </span>

                <span   v-if="props.row.status.lastcontact.length > 0 && isAlarm(props.row.status.lastcontact)" >
                  <i class="fas fa-exclamation-circle" style="color: red;" aria-hidden="true"></i>
                </span>
                
            </b-table-column>

            <!-- <b-table-column field="daysago" label="Days Ago" centered>
              <span v-if="props.row.status.lastcontact.length > 0">
                <span class="tag is-light">{{diffInDays(props.row.status.lastcontact)}} </span>
              </span>

              <span   v-if="props.row.status.lastcontact.length > 0 && isAlarm(props.row.status.lastcontact)" >
                <i class="fas fa-exclamation-circle" style="color: red;" aria-hidden="true"></i>
              </span>
            </b-table-column> -->

            <b-table-column field="channels" label="Channels">
              
              <ShowChannelIcons :contact='props.row' style="margin-bottom: 1em;"/>

            </b-table-column>     


            <!-- <b-table-column field="comment" label="Comment" width="300">
                {{ props.row.comment | truncate(35) }}
            </b-table-column> -->

            <!-- <b-table-column field="date" label="Date" centered>
                <span class="tag is-success">
                    {{ new Date(props.row.pdate).toLocaleDateString() }}
                </span> -->
            <!-- </b-table-column> -->
        </template>

        <template slot="detail" slot-scope="props">
            <article class="media">
                <!-- <figure class="media-left">
                    <p class="image is-64x64">
                        <img src="/static/img/placeholder-128x128.png">
                    </p>
                </figure> -->
                <div class="media-content">
                    <div class="content">
                        <p>
                            <!-- <strong>{{ props.row }} </strong>
                            <br> -->
                            
                            <!-- <strong>{{ props.row.comment }}</strong>
                            <br>
                            <strong>Amount: {{ props.row.status.custto }} €</strong>
                           
                            ContactID: {{props.row.contactid}}
                            <br>
                            UserID: {{props.row.userid}}
                            <br>
                            AccountID: {{props.row.accountid}} --> 


                            <b-button
                              @click="putSelectedContact(props.row); $router.push('/main/contact')"
                              icon-left="fas fa-angle-double-right"
                              type="is-primary">
                              GOTO Usercard 
                            </b-button>
                        </p>
                    </div>
                </div>
            </article>
        </template>

        <template slot="empty">
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p>
                        <b-icon
                            icon="emoticon-sad"
                            size="is-large">
                        </b-icon>
                    </p>
                    <p>Nothing here.</p>
                </div>
            </section>
        </template>
    </b-table>





  



<!-- ==== -->

  <!-- <div v-for="contact in contacts" v-bind:key="contact.id">
    <ListPanelItem :contact='contact' style="margin-bottom: 1em;"/>
  </div> -->

</div>
</template>

<script>
// import ListPanelItem from '@/components/main/topten/ListPanelItem.vue';
import ShowChannelIcons from '@/components/main/topten/ShowChannelIcons.vue';
import ShowClassification from '@/components/main/topten/ShowClassification.vue';

import { mapGetters, mapActions } from 'vuex';

import * as moment from 'moment';

export default {
  

  name: 'ListPanelTopTen',
  components: {
    // ListPanelItem,
    ShowChannelIcons,
    ShowClassification
  },
  props: {
    // msg: String,
  },
  data() {
    return  {
      sortField: 'total',
      sortOrder: 'desc',
      showDetailIcon: true,
      // localAllContacts: [],
      // myfilteredContacts: [],
      localSortedContacts: []
      
    }
  },
  created () {
    // this.fetchContacts() 
    this.sortLocallyUp()
  },
  computed: {
    ...mapGetters(['allContacts', 'selectedContact', 'getAccount']),
    // contactFromIndex () {
    //   return this.allContacts.find(contact => contact.id === this.selected)
    // },
  },
  methods: {
    ...mapActions(['fetchContacts','putSelectedContact']),
    // onFilterContacts() {
    //   // this.myfilteredContacts = this.filteredContacts('net')
    //   this.fetchFilteredContacts(this.searchstring)
    // },
    // filterLocally() {
    //   // console.log("filterLocally: "+this.searchstring+ "  "+this.localAllContacts.length)

    //   this.myfilteredContacts = this.localAllContacts.filter(
    //     contact => contact.name.toLowerCase().includes(this.searchstring.toLowerCase())
    //     )
    // },
    sortLocallyUp() {
      //..update via WATCH not working ... loading directly from store
      var localAllContacts = JSON.parse(JSON.stringify(this.allContacts))  //..making a copy (by parsing JSON )
      
      // console.log('sort locally')
      // console.log('sort locally' + this.localAllContacts.length)
      this.localSortedContacts = localAllContacts.sort(function(a,b){return b.status.custtotal - a.status.custtotal}) //.slice(0,10)
    },
    diffInDays(date) {
      let m1 = moment(new Date())
      let m2 = moment(date)
      return m1.diff(m2, 'days')
    },
    isAlarm(date) {
      let diffdays = this.diffInDays(date)
      if (diffdays > this.getAccount.returntime) return true
      return false
    }
    // sortLocallyDown() {
    //   // this.localAllContacts = JSON.parse(JSON.stringify(this.allContacts))  //..making a copy (by parsing JSON )
    //   this.mysortedContacts = this.localAllContacts.sort(function(a,b){return a.status.custtotal - b.status.custtotal})
    // }

  },
  watch: {
    allContacts (newValue) {
      //...make a copy of the object (even working with the original Object, it's needed) !!! important to make it reactive !!!
      this.localAllContacts = JSON.parse(JSON.stringify(newValue))  //..making a copy (by parsing JSON )
      this.sortLocallyUp()

      // this.mysortedContacts = this.localAllContacts.sort(function(a,b){return b.status.custtotal - a.status.custtotal})

      // this.mysortedContacts = this.sortLocally(this.localAllContacts)
      console.log("allContacts have changed (watched by @ListPanel-TopTen) "+this.localAllContacts.length)

    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>